export default {
  faas: {
    cost: null,
    tokenStakingContracts: [],
  },
};
